import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import UserContext from "../../context/user";

const useGetOsteopaths = (setSelecetedOsteopath) => {
  const { userProfile, callApi } = useContext(UserContext);

  return useQuery(["osteopath-list"], () => callApi(`/osteopath/search?offset=0&limit=50`), {
    enabled: !!userProfile,
    select: (data) => data.list,
    onSuccess: (data) => {
      if (data?.length === 1) {
        setSelecetedOsteopath(data?.[0]?.id);
      }
    },
  });
};

export default useGetOsteopaths;
